<script setup lang="ts">
import {
  ref,
  shallowRef,
  onMounted,
  defineAsyncComponent,
  PropType,
} from 'vue';
import { Logger } from '@/middlewares/sentry';
import { ProductType } from 'interface/data/productTypes';
import { StoreState } from 'pinia';

const props = defineProps({
  versionList: {
    type: Object,
    required: true,
  },
  productType: {
    type: String as PropType<ProductType>,
    required: true,
  },
  store: {
    /* eslint-disable @typescript-eslint/no-explicit-any */
    type: Function as PropType<StoreState<any>>,
    /* eslint-enable @typescript-eslint/no-explicit-any */
    required: true,
  },
});

const Version = shallowRef(null);
const componentLoaded = ref(false);

const { getCommonData } = props.store();

function pickVersion() {
  const isVersionExist = Object.values(props.versionList).includes(
    getCommonData.version,
  );

  if (isVersionExist) {
    Version.value = defineAsyncComponent(
      () =>
        import(
          `../../layouts/clients/${props.productType['toLowerCase']()}/${getCommonData.version}.vue`
        ),
    );
    componentLoaded.value = true;
  } else {
    Logger.error('Wrong event verion ' + getCommonData.version);
  }
}

onMounted(() => {
  pickVersion();
});
</script>

<template>
  <Version v-if="componentLoaded" buttons-disabled />
</template>
